import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: HelloSign",
  "description": "",
  "published": "2012-11-15T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-hellosign/swizec/5564"],
  "categories": "Contract, Dropbox, Evernote, Google, HelloSign, IPad, Snail mail, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Almost everybody signs `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Contract",
        "title": "Contract"
      }}>{`contracts`}</a>{`. They might not amount to much more than a firm handshake when shit hits the fan, but they put people's minds at ease so it doesn't seem we'll be getting rid of them any time soon.`}</p>
    <p>{`Signing contracts is annoying.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/hellosign-1024x443.png",
        "alt": "HelloSign",
        "title": "HelloSign"
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`My `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Signature",
        "title": "Signature"
      }}>{`signature`}</a>{` never spells anything, it's just a squiggle. A different squiggle every time, sometimes it doesn't look remotely similar page to page. Hell, if it's going to be just a squiggle I want it to at least look good, but I can't even do that every time.`}</p>
    <p>{`Not to mention how difficult getting busy people in the same room can be. Surely a 30 second signature isn't worth half an hour getting from one side of town to another?`}</p>
    <p>{`Things only get worse once you start doing business abroad.`}</p>
    <p>{`Somebody sends you a contract, you print it out, sign it, scan it back in, send it back and the other person must repeat this process. Then both of you get to print out the signedd contract to put in a file somewhere. Hooray for wasting time and paper. All those trees surely love us!`}</p>
    <p>{`You could also send the whole contract via `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Snail_mail",
        "title": "Snail mail"
      }}>{`snail mail`}</a>{`, avoiding any qualms with `}<em parentName="p">{`"I'm just printing, signing and scanning the last page of the document, so how well does this stand up in court anyway?"`}</em>{` ... but who's got that sort of patience?`}</p>
    <h2 {...{
      "id": "enter-hellosign-stage-left"
    }}>{`Enter `}<a parentName="h2" {...{
        "href": "http://hellosign.com"
      }}>{`HelloSign`}</a>{` stage left!`}</h2>
    <p>{`It's a simple `}<em parentName="p">{`free`}</em>{` service that makes signing documents easy. You just upload a file, drag your signature on top, enter an email address and click send. Wonderful!`}</p>
    <p>{`That's actually all I've ever used the service for. Even though it's also got `}<a parentName="p" {...{
        "href": "http://www.dropbox.com",
        "title": "Dropbox"
      }}>{`Dropbox`}</a>{`, Google Drive and `}<a parentName="p" {...{
        "href": "http://www.evernote.com",
        "title": "Evernote"
      }}>{`Evernote`}</a>{` integration. Plus there's an iPad and iPhone app nowadays, which sounds kinda cool. I should probably check it out.`}</p>
    <p>{`Aside from making my life very easy HelloSign it also keeps a clean version of my signature stored, so I can be sure it always looks the same and doesn't have any strange scanning artefacts. All it took was uploading a photo of a signed scrap of paper and HelloSign took care of the rest.`}</p>
    <p>{`I'm starting to feel bad I'm not paying for this ...`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/hellosign-ipad.png",
        "alt": "HelloSign on iPad",
        "title": "HelloSign on iPad"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/hellosign-ipad-signing.png",
        "alt": "iPad version let's you sign with your finger",
        "title": "iPad version let's you sign with your finger"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/prweb2012/10/prweb9926356.htm"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_97_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/prweb2012/10/prweb9926356.htm"
        }}>{`HelloSign Integrates with Google Drive; Launches Unlimited Free Signatures from Google Drive`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.programmableweb.com/2012/11/07/hellosign-api-enables-free-secure-esignature-integration/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/124091072_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.programmableweb.com/2012/11/07/hellosign-api-enables-free-secure-esignature-integration/"
        }}>{`HelloSign API Enables Free, Secure eSignature Integration`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.hellosign.com/info/api"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_0_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.hellosign.com/info/api"
        }}>{`Introducing the HelloSign API: Hassle-free eSignatures (YC W11)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.techno360.in/hellosign-easy-and-free-way-to-sign-documents/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/116485195_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.techno360.in/hellosign-easy-and-free-way-to-sign-documents/"
        }}>{`HelloSign: Easy and free way to sign documents`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.macworld.com/article/2010909/app-spotlight-sign-documents-on-the-go-with-hellosign.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/115803205_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.macworld.com/article/2010909/app-spotlight-sign-documents-on-the-go-with-hellosign.html"
        }}>{`App Spotlight: Sign documents on the go with HelloSign`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3c65e12d-8eb0-4974-a1bc-015265bc026a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      